module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "db centered-container-ns"
  }, [_c('div', {
    staticClass: "bg-white border-login ph3 ph4-ns mt6 mt0-ns pv5-ns br2-ns",
    attrs: {
      "id": "login-card"
    }
  }, [_c('h1', {
    staticClass: "f3 lh-copy fw3 tc"
  }, [_vm._v(_vm._s(_vm.$t('login.getcode', {
    getcode: 'Get a New Passcode'
  })))]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "mv4"
  }, [_c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t('login.enteracc', {
    enteracc: "Enter your account's cell phone number to receive a new passcode. You will receive the code by SMS and to the email address associated with your account. If you have multiple phones protected with AKKO, remember each phone has its own account and login."
  })))]), _vm._v(" "), _c('InputMask', {
    staticClass: "input-reset ba border-login pa2 mb2 db w-100 br1",
    attrs: {
      "id": "email",
      "type": "tel",
      "mask": "(999) 999-9999"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt4 mb3"
  }, [_c('ak-button', {
    staticClass: "br3-ns",
    attrs: {
      "disabled": !_vm.identifierValid,
      "primary": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.login.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('login.sendcode', {
    sendcode: 'Send me a New Passcode'
  })))])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f250465","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForgotPassword.vue
// module id = 1248
// module chunks = 0